export default __webpack_public_path__ + "93919062a17b70053a9a48425357145c.png";